import {
	ToDoListIdentifier,
	ToDoListIdentifierKind,
	WellKnownTodoListKind
} from "client/Api/Workspace/LiveInformation/ToDos/toDoListLiveInformation";
import { never } from "client_legacy/ndaw/errors";
import { buildFullUrlWithSingleSignOn, encodeGraphIdAccordingToToDoApp } from "./provider";
import { navigateTo } from "client_legacy/ndaw/navigator";

export function navigateToToDoList(
	list: ToDoListIdentifier,
	{ openInNewWindow }: { openInNewWindow: boolean; },
	onNavigate?: () => void
) {
	let relativeUrl: string;
	switch (list.kind) {
		case ToDoListIdentifierKind.Default:
			relativeUrl = "/tasks/inbox";
			break;
		case ToDoListIdentifierKind.WellKnown:
			switch (list.wellKnownListKind) {
				case WellKnownTodoListKind.FlaggedEmails:
					relativeUrl = "/tasks/flagged";
					break;
				default:
					never(list.wellKnownListKind);
			}
			break;
		case ToDoListIdentifierKind.Planner:
			relativeUrl = "/tasks/assigned_to_me";
			break;
		case ToDoListIdentifierKind.Specific:
			relativeUrl = `/tasks/${encodeGraphIdAccordingToToDoApp(list.id)}`;
			break;
		default:
			never(list);
	}

	if (onNavigate) {
		onNavigate();
	}

	const url: string = buildFullUrlWithSingleSignOn(relativeUrl);
	navigateTo(url, openInNewWindow);
}
